import { AspirationSite, ChuteSchedule } from '@/rtk-query.gql';

/* ------------------------------------------------------------------
 *  ACTIONS
 * ---------------------------------------------------------------- */
export enum ChuteSchedulerActions {
  UPDATE_SITE = 'chuteScheduler/UPDATE_SITE',
  UPDATE_INTERVAL = 'chuteScheduler/UPDATE_INTERVAL',
  UPDATE_START_TIME = 'chuteScheduler/UPDATE_START_TIME',

  /* multiple‑chute controls */
  TOGGLE_MULTI_CHUTE = 'chuteScheduler/TOGGLE_MULTI_CHUTE',
  UPDATE_MULTI_CHUTE_COUNT = 'chuteScheduler/UPDATE_MULTI_CHUTE_COUNT',

  /* UI flags */
  SET_LOADING = 'chuteScheduler/SET_LOADING',
  SET_ERROR = 'chuteScheduler/SET_ERROR',

  /* data */
  UPDATE_SCHEDULING_ROWS = 'chuteScheduler/UPDATE_SCHEDULING_ROWS',
  UPDATE_RESULTS_ROWS = 'chuteScheduler/UPDATE_RESULTS_ROWS',
  UPDATE_SELECTED_SCHEDULING_ROWS = 'chuteScheduler/UPDATE_SELECTED_SCHEDULING_ROWS',
  UPDATE_SELECTED_RESULTS_ROWS = 'chuteScheduler/UPDATE_SELECTED_RESULTS_ROWS',
  UPDATE_IS_SORTED = 'chuteScheduler/UPDATE_IS_SORTED',
}

/* ------------------------------------------------------------------
 *  STATE
 * ---------------------------------------------------------------- */
export interface ChuteSchedulerState {
  site?: AspirationSite | null;
  interval: number;
  startTime: string;

  /* multiple‑chute */
  multiChuteEnabled: boolean;
  multiChuteCount: number;

  /* flags */
  loading: boolean;
  error: string | null;

  /* data rows */
  schedulingRows: ChuteSchedule[];
  resultsRows: ChuteSchedule[];

  /* selection */
  selectedSchedulingRows: ChuteSchedule[];
  selectedResultsRows: ChuteSchedule[];

  isSorted: boolean;
}

export const initialState: ChuteSchedulerState = {
  site: null,
  interval: 15,
  startTime: '0900',

  multiChuteEnabled: false,
  multiChuteCount: 1,

  loading: false,
  error: null,

  schedulingRows: [],
  resultsRows: [],

  selectedSchedulingRows: [],
  selectedResultsRows: [],

  isSorted: false,
};

/* ------------------------------------------------------------------
 *  REDUCER
 * ---------------------------------------------------------------- */
export default function reducer(
  state: ChuteSchedulerState = initialState,
  action: any,
): ChuteSchedulerState {
  switch (action.type) {
    case ChuteSchedulerActions.UPDATE_SITE:
      return { ...state, site: action.payload };

    case ChuteSchedulerActions.UPDATE_INTERVAL:
      return { ...state, interval: action.interval };

    case ChuteSchedulerActions.UPDATE_START_TIME:
      return { ...state, startTime: action.startTime };

    /* multiple‑chute */
    case ChuteSchedulerActions.TOGGLE_MULTI_CHUTE:
      return { ...state, multiChuteEnabled: action.enabled };
    case ChuteSchedulerActions.UPDATE_MULTI_CHUTE_COUNT:
      return { ...state, multiChuteCount: action.count };

    /* flags */
    case ChuteSchedulerActions.SET_LOADING:
      return { ...state, loading: action.loading };
    case ChuteSchedulerActions.SET_ERROR:
      return { ...state, error: action.error };

    /* data rows */
    case ChuteSchedulerActions.UPDATE_SCHEDULING_ROWS:
      return { ...state, schedulingRows: action.rows };
    case ChuteSchedulerActions.UPDATE_RESULTS_ROWS:
      return { ...state, resultsRows: action.rows };

    /* selection */
    case ChuteSchedulerActions.UPDATE_SELECTED_SCHEDULING_ROWS:
      return { ...state, selectedSchedulingRows: action.rows };
    case ChuteSchedulerActions.UPDATE_SELECTED_RESULTS_ROWS:
      return { ...state, selectedResultsRows: action.rows };

    case ChuteSchedulerActions.UPDATE_IS_SORTED:
      return { ...state, isSorted: action.isSorted };

    default:
      return state;
  }
}
